import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { useDebounce } from 'use-debounce';
import Menu from '../../components/Menu/Menu';
import Footer from '../../components/Footer/Footer';
import Pagination from '../../components/Pagination/Pagination';
import SearchSymbol from '../../components/SearchSymbol/SearchSymbol';
import Toast from '../../components/Toast/Toast';
import { getFiliados } from '../../services/FiliadosService';
import FiliadoRow from './FiliadoRow';


function Filiados() {
    const location = useLocation();
    const params = useParams();
    const navigate = useNavigate();
    const [search, setSearch] = useState(params.nome || '');
    const [Filiados, setFiliados] = useState([]);
    const [editUser, setEditUser] = useState({});
    const [count, setCount] = useState(0);
    const [page, setPage] = useState(parseInt(new URLSearchParams(location.search).get('page') || '1'));
    const [notification, setNotification] = useState({ type: '', text: '' });

    const [debouncedSearch] = useDebounce(search, 500);


    // Later in the useEffect hook
    useEffect(() => {
        const token = localStorage.getItem('token');
        getFiliados(debouncedSearch, page, token).then(result => {
            setFiliados(result.rows);
            setCount(result.count);
        }).catch(err => {
            console.error(err.response ? err.response.data : err.message);
            setNotification({ type: 'error', text: err.response ? err.response.data : err.message });
        });
    }, [debouncedSearch, page]);



    useEffect(() => {
        function handleLocationChange(location) {
            const newPage = parseInt(new URLSearchParams(location.search).get('page') || '1');
            setPage(newPage);
        }

        handleLocationChange(location); // Initialize with current location

        // Potencialmente, adicionar um listener aqui se necessário para mudanças de localização
        // return () => { removeListener(); };
    }, [location]);


    const onSearchChange = (event) => {
        setSearch(event.target.value);
    };

    const onNewUserClick = () => {
        setEditUser({ nome: '', isActive: true });
    };

    const onEditClick = (event) => {
        const id = parseInt(event.target.id.replace('edit', ''));
        const user = Filiados.find(u => u.id === id);
        setEditUser(user);
    };

    const onModalSubmit = () => {
        navigate(0);
    };

    return (
        <React.Fragment>
            <Menu />
            <main className="content">
                {/* Remaining JSX */}
                {/* Cabeçalho da página */}
                <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                    <div className="d-block mb-4 mb-md-0">
                        {/* <h1 className="h4">Filiados...</h1> */}
                        <nav aria-label="breadcrumb" className="d-none d-md-inline-block">
                            <ol className="breadcrumb breadcrumb-dark breadcrumb-transparent mb-0">
                                <li className="breadcrumb-item">
                                    <a href="#">
                                        <svg className="icon icon-xxs" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"></path></svg>
                                    </a>
                                </li>
                                {/* <li className="breadcrumb-item"><a href="#">Category</a></li> */}
                                <li className="breadcrumb-item active" aria-current="page">Usuários</li>
                            </ol>
                        </nav>
                    </div>
                    <div className="btn-toolbar mb-md-0">
                        <div className="d-inline-flex align-items-center">
                            {/* <NewUserButton onClick={onNewUserClick} /> */}
                            <button className="btn btn-sm btn-primary" onClick={onNewUserClick}></button>
                        </div>
                        <div className="ms-2 ms-lg-3">
                            {/* Campo para consulta */}

                            <SearchSymbol placeholder="User" onChange={onSearchChange} />
                        </div>
                    </div>
                </div>

                {/* <h1 className="h4">3 - Pontos - Montar tela..</h1> */}

                <div className="row">
                    <div className="col-12">
                        {/* Corpo da pagina */}
                        {/* INICIO DA TABELA */}
                        <div className="card card-body border-0 shadow table-wrapper table-responsive">
                            <table className="table table-hover">
                                <thead>
                                    <tr>
                                        <th className="border-gray-200">View</th>
                                        <th className="border-gray-200">Código</th>
                                        <th className="border-gray-200">Nome</th>
                                        <th className="border-gray-200">Email</th>
                                        <th className="border-gray-200">Atualizado</th>
                                        <th className="border-gray-200">Ativo</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        Filiados.map(Filiados => (
                                            <FiliadoRow key={Filiados.id} data={Filiados} onEditClick={onEditClick} />
                                        ))
                                    }
                                </tbody>
                            </table>
                            <Pagination count={count} />
                        </div>
                        {/* FINAL DA TABELA */}


                    </div>
                </div>
                {/* Rodape da página */}
                <Footer />
            </main>
            {/* <UserModal data={editUser} onSubmit={onModalSubmit} /> */}
            <Toast type={notification.type} text={notification.text} />
        </React.Fragment>
    );
}

export default Filiados;
